/** Loyihani qo'llab-quvvatlash (donat kartasi) va "Fikr va takliflar" varag'i. */
import { useState } from "react";
import { t } from "../i18n";
import { toast } from "../lib/toast";
import { sync } from "../lib/sync";
import { ApiError } from "../lib/api";
import { Ic } from "./Icon";
import { SheetBox } from "./Sheet";

/** Donat kartasi (Uzcard). */
export const DONATE_CARD = "5614682116190846";
export const DONATE_HOLDER = "Zikirillayev Khojiakbar";
const CARD_FMT = DONATE_CARD.replace(/(\d{4})(?=\d)/g, "$1 ");

export function copyCard() {
    try {
        navigator.clipboard.writeText(DONATE_CARD).then(
            () => toast(t("Karta raqami nusxalandi")),
            () => toast(CARD_FMT),
        );
    } catch {
        toast(CARD_FMT);
    }
}

/** Karta raqami + nusxalash — Profil bo'limida ham, eslatma varag'ida ham. */
export function DonateBody() {
    return (
        <>
            <span className="t13">
                {t(
                    "Donat qilishingiz shunchaki loyihaning rivoji uchun emas, balki ilm yoʻlida qoʻshgan hissangiz bo‘ladi.",
                )}
            </span>
            <button
                className="cardno"
                onClick={copyCard}
                aria-label={t("Karta raqamini nusxalash")}
            >
                <span className="cap" style={{ color: "var(--primary-ink)" }}>
                    Uzcard
                </span>
                <b>{CARD_FMT}</b>
                <span
                    className="t13"
                    style={{ fontWeight: 700, color: "var(--ink)" }}
                >
                    {DONATE_HOLDER}
                </span>
                <span
                    className="row g6 t12"
                    style={{ color: "var(--primary-ink)", fontWeight: 700 }}
                >
                    <Ic n="copy" size={14} />
                    {t("Karta raqamini nusxalash")}
                </span>
            </button>
        </>
    );
}

/** Profil bo'limidagi doimiy blok. */
export function DonateCard() {
    return (
        <section
            className="card col g10"
            style={{ padding: 16, borderRadius: 22 }}
        >
            <b className="t15b row g8">
                <Ic n="heart" size={18} style={{ color: "var(--peach-ink)" }} />
                {t("Loyihani qoʻllab-quvvatlash")}
            </b>
            <DonateBody />
        </section>
    );
}

/** Har kirishda bir marta ko'rsatiladigan eslatma (App). */
export function DonateSheet({ onClose }: { onClose: () => void }) {
    return (
        <SheetBox title={t("Loyihani qoʻllab-quvvatlash")} onClose={onClose}>
            <DonateBody />
            <span className="t12">
                {t("Rahmat! 💜 Karta raqami Profil boʻlimida ham turadi.")}
            </span>
            <button
                className="btn soft"
                style={{ height: 46 }}
                onClick={onClose}
            >
                {t("Keyinroq")}
            </button>
        </SheetBox>
    );
}

const KINDS: Array<["bug" | "idea" | "other", string]> = [
    ["bug", "Muammo"],
    ["idea", "Taklif"],
    ["other", "Boshqa"],
];

/** Fikr va takliflar: kategoriya + matn → POST /v1/feedback. */
export function FeedbackSheet({
    onClose,
    screen = "profile",
}: {
    onClose: () => void;
    screen?: string;
}) {
    const [kind, setKind] = useState<"bug" | "idea" | "other">("idea");
    const [text, setText] = useState("");
    const [busy, setBusy] = useState(false);
    const send = async () => {
        const tx = text.trim();
        if (tx.length < 3) {
            toast(t("Kamida 3 ta belgi yozing"));
            return;
        }
        setBusy(true);
        try {
            await sync.feedback({ kind, text: tx.slice(0, 500), screen });
            onClose();
            toast(t("Rahmat! Fikringiz yuborildi"));
        } catch (e) {
            toast(
                e instanceof ApiError && e.status === 429
                    ? t("Bugun yetarli — rahmat! Ertaga davom etamiz")
                    : t("Yuborib boʻlmadi — internetni tekshiring"),
            );
        } finally {
            setBusy(false);
        }
    };
    return (
        <SheetBox title={t("Fikr va takliflar")} onClose={onClose}>
            <span className="t13">
                {t("Biz har bir fikrni oʻqiymiz. Nima haqida yozmoqchisiz?")}
            </span>
            <div className="row g8 wrapr">
                {KINDS.map(([k, l]) => (
                    <button
                        key={k}
                        className={`chipx${kind === k ? " act" : ""}`}
                        style={{ fontSize: 13, padding: "8px 14px" }}
                        onClick={() => setKind(k)}
                    >
                        {t(l)}
                    </button>
                ))}
            </div>
            <div className="field ta">
                <textarea
                    maxLength={500}
                    value={text}
                    placeholder={t(
                        "Fikringiz, taklifingiz yoki duch kelgan muammo…",
                    )}
                    onChange={(e) => setText(e.target.value)}
                    aria-label={t("Fikr va takliflar")}
                />
            </div>
            <div className="between t12">
                <span>{text.length}/500</span>
            </div>
            <button
                className="btn"
                style={{ height: 48 }}
                disabled={busy}
                onClick={send}
            >
                {t("Yuborish")}
            </button>
        </SheetBox>
    );
}
